// extracted by mini-css-extract-plugin
export var numpadContainer = "_ro-1";
export var phoneButton = "_ro-0";